const painSymptoms=[

{symptom:"chestPain",
displayAs:"Chest pain",
questionGroup:"trunkPain"
},

{symptom:"upperAbdoPain",
displayAs:"Upper Abdominal Pain",
questionGroup:"trunkPain"
},

{symptom:"abdoPain",
displayAs:"Abdominal Pain",
questionGroup:"trunkPain"
},

{symptom:"pelvicPain",
displayAs:"Pelvic Pain",
questionGroup:"trunkPain"
},

{
symptom:"backPain",
displayAs:"Back Pain",
questionGroup:"trunkPain"
},

{symptom: "bonePain",
displayAs: "Persistent / unexplained bone pain",
questionGroup:"bonePain"
},

{symptom: "nonSpecPain",
displayAs: "Persistent non-specific pain",
questionGroup: "nonSpecPain"
},

{symptom:"alcLnPain",
displayAs:"Alcohol-induced lymph node pain",
questionGroup: "alcLnPain"
}

]


export default painSymptoms